import {DOCUMENT_TYPE_ABOUT_LANDING_PAGE} from '@/components/about/about-landing-page/constants';
import {DOCUMENT_TYPE_ABOUT} from '@/components/about/constants';
import {DOCUMENT_TYPE_ARTICLE_LANDING_PAGE} from '@/components/article/article-landing-page/constants';
import {DOCUMENT_TYPE_ARTICLE} from '@/components/article/constants';
import {DOCUMENT_TYPE_CLIENTS_FRONTPAGE} from '@/components/client/clients-frontpage/constants';
import {DOCUMENT_TYPE_CLIENT} from '@/components/client/constants';
import {DOCUMENT_TYPE_FRONTPAGE} from '@/components/frontpage/constants';
import {DOCUMENT_TYPE_PAGE} from '@/components/page/constants';
import {DOCUMENT_TYPE_PARTNER} from '@/components/partner/partner-page/constants';
import {DOCUMENT_TYPE_PARTNERS_FRONTPAGE} from '@/components/partner/partners-frontpage/constants';
import {DOCUMENT_TYPE_PROJECT} from '@/components/project/constants';
import {DOCUMENT_TYPE_PROJECTS_FRONTPAGE} from '@/components/project/projects-frontpage/constants';
import {DOCUMENT_TYPE_SERVICE_LANDING_PAGE} from '@/components/service/service-landing-page/constants';
import {DOCUMENT_TYPE_SERVICE_CATEGORY} from '@/components/service-category/constants';
import type {SITE_SETTINGS_QUERYResult} from '@/sanity/types';
import {
	ABOUT_PAGE_PATH,
	ARTICLES_PAGE_PATH,
	CLIENTS_PAGE_PATH,
	PARTNERS_PAGE_PATH,
	PROJECTS_PAGE_PATH,
	SERVICES_PAGE_PATH,
} from '@/shared/constants';

import type {LinkableDocumentTypes} from './schema';

export const LINK_FRAGMENT = `//groq
	...,
	reference-> {
		title,
		_type,
		"slug": slug.current,
	}
`;

export type LinkFragment = Omit<
	NonNullable<
		NonNullable<
			NonNullable<SITE_SETTINGS_QUERYResult>['footerLinks']
		>[number]
	>,
	'_type' | '_key'
>;

export const internalLinkToHref = (
	documentType?: LinkableDocumentTypes,
	slug?: string,
) => {
	switch (documentType) {
		case DOCUMENT_TYPE_FRONTPAGE:
			return '/';
		case DOCUMENT_TYPE_PAGE:
			return slug ? `/${slug}` : '#';
		case DOCUMENT_TYPE_ARTICLE_LANDING_PAGE:
			return ARTICLES_PAGE_PATH;
		case DOCUMENT_TYPE_ARTICLE:
			return slug ? `${ARTICLES_PAGE_PATH}/${slug}` : '#';
		case DOCUMENT_TYPE_PROJECTS_FRONTPAGE:
			return PROJECTS_PAGE_PATH;
		case DOCUMENT_TYPE_PROJECT:
			return slug ? `${PROJECTS_PAGE_PATH}/${slug}` : '#';
		case DOCUMENT_TYPE_SERVICE_CATEGORY:
			return slug ? `${SERVICES_PAGE_PATH}/${slug}` : '#';
		case DOCUMENT_TYPE_SERVICE_LANDING_PAGE:
			return SERVICES_PAGE_PATH;
		case DOCUMENT_TYPE_ABOUT_LANDING_PAGE:
			return ABOUT_PAGE_PATH;
		case DOCUMENT_TYPE_ABOUT:
			return slug ? `${ABOUT_PAGE_PATH}/${slug}` : '#';
		case DOCUMENT_TYPE_CLIENTS_FRONTPAGE:
			return CLIENTS_PAGE_PATH;
		case DOCUMENT_TYPE_CLIENT:
			return slug ? `${CLIENTS_PAGE_PATH}/${slug}` : '#';
		case DOCUMENT_TYPE_PARTNERS_FRONTPAGE:
			return PARTNERS_PAGE_PATH;
		case DOCUMENT_TYPE_PARTNER:
			return slug ? `${PARTNERS_PAGE_PATH}/${slug}` : '#';
		default:
			console.warn(
				'Document type not a known linkable type:',
				documentType,
			);
			return '#';
	}
};

export const linkFragmentToHref = (link: LinkFragment) => {
	if (link.type === 'internal') {
		return internalLinkToHref(
			link.reference?._type,
			link.reference?.slug ?? '',
		);
	}

	if (link.type === 'external') {
		return link.href ?? '#';
	}

	return '#';
};
